import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=63fd44ce&scoped=true&lang=pug"
import script from "./Talk.vue?vue&type=script&lang=js"
export * from "./Talk.vue?vue&type=script&lang=js"
import style0 from "./Talk.vue?vue&type=style&index=0&id=63fd44ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fd44ce",
  null
  
)

export default component.exports